import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMicrosoftComponent } from './simple-icons-microsoft.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMicrosoftComponent ],
    exports:      [ SimpleIconsMicrosoftComponent ],
    bootstrap:    []
})
export class SimpleIconsMicrosoftModule {}
